<div class="wrapper">
    <div class="container">
        <div class="heading-container">
            <mat-icon class="icon" (click)="goBack()"><mat-icon>arrow_back</mat-icon></mat-icon>
            <span class="header">{{ title }}</span>
        </div>

        <div *ngIf="!isUserExist" class="profile-address-container">
            <profile-details
                #profileDetailRef
                [hideAgeAndShowMobile]="true"
                (profileData)="receiveProfileData($event)"
            ></profile-details>
            <app-address
                #addressDetailRef
                [showNameAndMobile]="true"
                (addressData)="receiveAddressData($event)"
            ></app-address>
        </div>

        <div *ngIf="isUserExist">
            <app-address
                [selectedAddressId]="id"
                [showNameAndMobile]="true"
                #addressDetailRef
                (addressData)="receiveAddressData($event)"
            ></app-address>
        </div>
        <div class="btn-content">
            <app-button
                variant="hero"
                buttonClass="explore-btn"
                (onClick)="submitForm()"
                [disabled]="!isFormDataValid()"
            >
                {{ "userDetails.button.save&ContinueBtn" | translate }}
            </app-button>
        </div>
        <br />
    </div>
</div>
